import {
	DateAndTime_UPDATE_REQUEST,
	DateAndTime_UPDATE_SUCCESS,
	DateAndTime_UPDATE_FAILURE,
	DateAndTime_UPDATE_RESET,
	UNREAD_RECORD_UPLOAD_FAILURE,
	UNREAD_RECORD_UPLOAD_SUCCESS,
	UNREAD_RECORD_UPLOAD_REQUEST,
} from "./devicesynchronizeConstant";

export const DeviceSyncReducer = (
	initialState = {
		DateAndTimes: [],
	},
	action
) => {
	switch (action.type) {
		//DateAndTime Update
		case DateAndTime_UPDATE_REQUEST:
			return { ...initialState, updateLoading: true };
		case DateAndTime_UPDATE_SUCCESS:
			return {
				...initialState,
				updateLoading: false,
				updateSuccess: true,
			};
		case DateAndTime_UPDATE_FAILURE:
			return {
				...initialState,
				updateLoading: false,
				updateError: action.payload,
			};
		case DateAndTime_UPDATE_RESET:
			return { ...initialState,DateAndTime: {} };



			case UNREAD_RECORD_UPLOAD_REQUEST:
			return { ...initialState, updateUnreadRecordLoading: true };
		case UNREAD_RECORD_UPLOAD_SUCCESS:
			return {
				...initialState,
				updateUnreadRecordLoading: false,
				updateUnreadRecordSuccess: true,
			};
		case UNREAD_RECORD_UPLOAD_FAILURE:
			return {
				...initialState,
				updateUnreadRecordLoading: false,
				updateUnreadRecordError: action.payload,
			};

		default:
			return initialState;
	}
};
